import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import { SECURITY_ROLE_KEY } from '../models/security/security-role-keys';

export const getingeMenu: MenuItem[] = [
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_CLAIMS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_ASSESSMENTS,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MY_DEVELOPMENT_ACTIONS,
    securityRoles: SECURITY_ROLE_KEY.User,
    hideItem: true,
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.EVENTS_CALENDAR,
    hideItem: true,
    securityRoles: [],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MATRICES,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_COMPETENCY_MATRIX,
        hideItem: true,
        securityRoles: [],
      },
    ],
  },
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN,
    securityRoles: SECURITY_ROLE_KEY.JobRolePeople,
    subMenu: [
      {
        hideItem: true,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_FRAMEWORK,
        securityRoles: [],
      },
      {
        hideItem: true,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_MATRIX_SETTINGS,
        securityRoles: [],
      },
      {
        hideItem: true,
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_PASSPORT,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_OBSERVATION_CHECKLISTS,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_QUESTION_LISTVIEW,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_COMPETENCY_LIBRARY,
        hideItem: true,
      },
      {
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_LEVEL_GROUP_LIBRARY,
        hideItem: true,
      },
    ],
  },
];
